var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckCircleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    viewBox: "0 96 960 960",
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m419.5 641.5-78.557-79.057Q328 550 309.389 550q-18.611 0-32.889 13.5-13 14-13 32.5t13.824 30.824L386.5 737q13.773 14 32.636 14Q438 751 453 737l225-226q14.5-13.5 14.5-31.611T678 446.5q-14-12.5-33.111-12-19.111.5-32.257 12.868L419.5 641.5ZM480.138 996q-87.045 0-163.691-32.847-76.646-32.846-133.713-90.012-57.067-57.166-89.9-133.603Q60 663.101 60 576.138q0-88.045 32.847-164.691t89.855-133.515q57.009-56.87 133.519-89.901Q392.732 155 479.779 155q88.128 0 164.892 32.967 76.764 32.966 133.559 89.802 56.795 56.836 89.783 133.451Q901 487.835 901 576q0 87.182-33.044 163.812-33.044 76.63-90.013 133.575-56.968 56.946-133.405 89.779Q568.101 996 480.138 996Z",
    fill: "#6BBE66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleIcon);
export default __webpack_public_path__ + "static/media/CheckCircleIcon.dfe709421a3b97872d071e8a60feca47.svg";
export { ForwardRef as ReactComponent };